export function capitalize (string: string): string {
  const head = string.charAt(0)
  const tail = string.slice(1)

  return head.toLocaleUpperCase() + tail
}

export function camelCase (stringToCamelCase: string): string {
  const noSpecialCharacters = stringToCamelCase.replace(/[^a-zA-Z0-9 ]/g, '')

  const words = noSpecialCharacters.split(' ')

  const wordsToJoin = []
  const firstWord = words[0].toLocaleLowerCase()

  wordsToJoin.push(firstWord)

  for (let index = 1; index < words.length; index++) {
    wordsToJoin.push(capitalize(words[index].toLocaleLowerCase()))
  }

  return wordsToJoin.join('')
}

const windows1252HighChars = [
  '\u00A0-\u00FF',
  '\u20AC',
  '\u201A',
  '\u0192',
  '\u201E',
  '\u2026',
  '\u2020',
  '\u2021',
  '\u02C6',
  '\u2030',
  '\u0160',
  '\u2039',
  '\u0152',
  '\u017D',
  '\u2018',
  '\u2019',
  '\u201C',
  '\u201D',
  '\u2022',
  '\u2013',
  '\u2014',
  '\u02DC',
  '\u2122',
  '\u0161',
  '\u203A',
  '\u0153',
  '\u017E',
  '\u0178',
].join('')
const suspiciousUtf8Markers = new RegExp(
  `(?:Ã[${windows1252HighChars}]|Â[${windows1252HighChars}]|â[${windows1252HighChars}]{2})`
)
const replacementCharacter = '\uFFFD'
const windows1252CharToByte = new Map<string, number>([
  ['€', 0x80],
  ['‚', 0x82],
  ['ƒ', 0x83],
  ['„', 0x84],
  ['…', 0x85],
  ['†', 0x86],
  ['‡', 0x87],
  ['ˆ', 0x88],
  ['‰', 0x89],
  ['Š', 0x8A],
  ['‹', 0x8B],
  ['Œ', 0x8C],
  ['Ž', 0x8E],
  ['‘', 0x91],
  ['’', 0x92],
  ['“', 0x93],
  ['”', 0x94],
  ['•', 0x95],
  ['–', 0x96],
  ['—', 0x97],
  ['˜', 0x98],
  ['™', 0x99],
  ['š', 0x9A],
  ['›', 0x9B],
  ['œ', 0x9C],
  ['ž', 0x9E],
  ['Ÿ', 0x9F],
])

export function repairTextEncoding (value: string): string {
  if (!suspiciousUtf8Markers.test(value)) {
    return value
  }

  try {
    const bytes: number[] = []

    for (const character of Array.from(value)) {
      const byte = toWindows1252Byte(character)

      if (byte === null) {
        return value
      }

      bytes.push(byte)
    }

    const decoded = new TextDecoder('utf-8').decode(Uint8Array.from(bytes))

    return !decoded.includes(replacementCharacter) && scoreMojibake(decoded) < scoreMojibake(value)
      ? decoded
      : value
  } catch {
    return value
  }
}

function scoreMojibake (value: string): number {
  return (value.match(new RegExp(suspiciousUtf8Markers.source, 'g')) ?? []).length
}

function toWindows1252Byte (character: string): number | null {
  const codePoint = character.charCodeAt(0)

  if (codePoint <= 0xFF) {
    return codePoint
  }

  return windows1252CharToByte.get(character) ?? null
}
